import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * Move dialog — directory tree picker for relocating items.
 *
 * Renders as a slide-over drawer from the right edge. The library
 * tree stays visible while the user picks a destination.
 */
import { useCallback, useEffect, useState } from 'react';
import { SlideDrawer } from './SlideDrawer';
export function MoveDialog({ open, itemName, directories, isValidTarget, onMove, onCancel, }) {
    const [selectedPath, setSelectedPath] = useState([]);
    useEffect(() => {
        if (open) {
            setSelectedPath([]);
        }
    }, [open]);
    const handleMove = useCallback(() => {
        onMove(selectedPath);
    }, [selectedPath, onMove]);
    const isCurrentTargetValid = isValidTarget ? isValidTarget(selectedPath) : true;
    return (_jsxs(SlideDrawer, { open: open, title: `Move "${itemName}"`, onClose: onCancel, footer: _jsxs(_Fragment, { children: [_jsx("button", { className: "ac-btn ac-btn-sm", onClick: onCancel, children: "Cancel" }), _jsx("button", { className: "ac-btn ac-btn-sm ac-btn-primary", onClick: handleMove, disabled: !isCurrentTargetValid, children: "Move" })] }), children: [_jsx("p", { className: "ac-text-muted", style: { margin: '0 0 12px', fontSize: 'var(--ac-text-sm)' }, children: "Select the destination directory:" }), _jsxs("div", { className: "ac-save-dialog-tree", children: [_jsx("button", { className: `ac-save-dialog-dir ${selectedPath.length === 0 ? 'ac-save-dialog-dir--selected' : ''}`, onClick: () => setSelectedPath([]), children: "/ (top level)" }), directories.map((dir) => {
                        const dirFullPath = [...dir.path, dir.name];
                        const isSelected = dirFullPath.join('/') === selectedPath.join('/');
                        const valid = isValidTarget ? isValidTarget(dirFullPath) : true;
                        return (_jsx("button", { className: `ac-save-dialog-dir ${isSelected ? 'ac-save-dialog-dir--selected' : ''} ${!valid ? 'ac-save-dialog-dir--disabled' : ''}`, style: { paddingLeft: `${0.5 + (dir.depth + 1) * 1.25}rem` }, onClick: () => valid && setSelectedPath(dirFullPath), disabled: !valid, children: dir.name }, dir.id));
                    })] })] }));
}
//# sourceMappingURL=MoveDialog.js.map